import {
	Footer as DsFooter,
	FooterLinkGroup,
	FooterSection,
	FooterSectionGroup,
	LegalLinks,
	SocialLinks,
	SvgFromUrl,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { Text } from '@dsx/react';
import footerLogo from '../../assets/images/ds-mxt-logo.svg';
import styles from './Footer.module.css';

export const Footer = () => {
	const currentYear = new Date().getFullYear();
	const copyright = `©2009-${currentYear} Direct Supply, Inc. All rights reserved.`;

	return (
		<div className={styles['footer-container']}>
			<DsFooter
				header={<SvgFromUrl url={footerLogo} width="250px" height="78px" />}
				subFooter={
					<LegalLinks
						links={[
							{
								children: 'Legal Information',
								href: '/legal',
							},
							{
								children: 'Terms of Use',
								href: '/legal/terms-of-use',
							},
							{
								children: 'Privacy Policy',
								href: '/legal/privacy-policy',
							},
							{
								children: 'Cookie Policy',
								href: '/legal/cookie-policy',
							},
							{
								children: 'Applicant Privacy',
								href: '/legal/application-privacy',
							},
							{
								children: 'California Collection Notice',
								href: '/legal/privacy-policy#california-collection-notice',
							},
						]}
						copyrightText={copyright}
					/>
				}
			>
				<FooterSectionGroup key="contact">
					<FooterSection title="Contact" columnCount={1} columnWidth="370px">
						<div>
							<Text variant="body-small" className={styles['footer-text']}>
								Have questions or need to get in touch about a project?
							</Text>
							<TrackingLink
								href="/contact/"
								size="small"
								linkStyle="standalone"
								actionIndicator="MdArrowForward"
								clickType="footer_link"
							>
								Drop us a line
							</TrackingLink>
						</div>
					</FooterSection>
					<SocialLinks
						links={[
							{
								href: 'https://www.facebook.com/directsupply',
								site: 'facebook',
							},
							{
								href: 'https://twitter.com/_DirectSupply',
								site: 'twitterX',
							},
							{
								href: 'http://www.linkedin.com/company/direct-supply',
								site: 'linkedin',
							},
							{
								href: 'http://www.youtube.com/c/directsupply',
								site: 'youtube',
							},
						]}
					/>
				</FooterSectionGroup>

				<FooterSection
					key="maxwell-thomas"
					title="Maxwell Thomas®"
					columnCount={2}
					columnWidth="370px"
				>
					<FooterLinkGroup
						links={[
							{ href: '/products', children: 'Products' },
							{ href: '/quick-ship', children: 'Quick-Ship' },
							{ href: '/fabrics', children: 'Fabrics' },
							{ href: '/finishes', children: 'Finishes' },
						]}
					/>

					<FooterLinkGroup
						links={[
							{ href: '/about', children: 'About us' },
							{ href: '/resources', children: 'Resources' },
							{ href: '/contact', children: 'Contact' },
						]}
					/>
				</FooterSection>
			</DsFooter>
		</div>
	);
};
